import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import { BASE_URL } from '../../../../config';
import Modal from '../../../../components/SolvPatternLibrary/Modal';
import { colors } from '../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../constants/text';
import { analyticsTrackEvent } from '../../../../core/analytics';
import { SHARE_WITH_SOCIAL_MEDIA_CLICK } from '../../../../core/analytics/events';
import FacebookIcon from '../../../SolvPatternLibrary/Icons/Facebook';
import TwitterIcon from '../../../SolvPatternLibrary/Icons/Twitter';
import LinkedinIcon from '../../../SolvPatternLibrary/Icons/Linkedin';
import GooglePlusIcon from '../../../SolvPatternLibrary/Icons/GooglePlus';
import MailIcon from '../../../SolvPatternLibrary/Icons/Mail';
import { getCustomization, SHARE_THE_CDP } from '../../util/customization';

const StyledFacebookShareButton = styled(FacebookShareButton)`
  svg {
    width: 17px;
  }

  :focus {
    outline: none;
  }
`;

const StyledTwitterShareButton = styled(TwitterShareButton)`
  svg {
    width: 20px;
  }

  :focus {
    outline: none;
  }
`;

const StyledLinkedinShareButton = styled(LinkedinShareButton)`
  svg {
    width: 17px;
  }

  :focus {
    outline: none;
  }
`;

const StyledGooglePlusShareButton = styled(GooglePlusShareButton)`
  svg {
    width: 27px;
  }

  :focus {
    outline: none;
  }
`;

const ModalContent = styled.div`
  margin: 0 20px 28px 20px;
`;

const ModalTitle = styled.div`
  color: ${colors.squid};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.quiteExtraExtraLarge};
  margin: 20px 0 36px;
  text-align: center;
`;

const ShareButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
  border-bottom: ${({ borderBottom }) => borderBottom && `1px solid ${colors.fatherJohnMisty}`};
  cursor: pointer;
`;

const ShareButtonContent = styled.div`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: left;
`;

const ShareButtonText = styled.span`
  color: ${colors.link};
  font-family: ${fontFamily.bold};
  margin-left: 24px;
`;

const MailShareButton = ({ onClick, children }) => <div onClick={onClick}>{children}</div>;

MailShareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.object,
};

export default class ShareModal extends PureComponent {
  static propTypes = {
    locationUrl: PropTypes.string.isRequired,
    openMailApp: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    location: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.fullUrl = `${BASE_URL}${props.locationUrl}`;
    const customization = getCustomization(SHARE_THE_CDP, { location: this.props.location });
    this.modalTitle = customization.modalTitle;
  }

  buildShareButton = ({ name, ShareButton, Icon, onClick }, i, arr) => {
    const isLastItem = i === arr.length - 1;

    return (
      <ShareButton url={this.fullUrl} onClick={onClick} key={name}>
        <ShareButtonContainer onClick={this.trackSocialMediaClick(name)} borderBottom={!isLastItem}>
          <ShareButtonContent>
            <Icon />
            <ShareButtonText>{name}</ShareButtonText>
          </ShareButtonContent>
        </ShareButtonContainer>
      </ShareButton>
    );
  };

  trackSocialMediaClick = name => () =>
    analyticsTrackEvent(SHARE_WITH_SOCIAL_MEDIA_CLICK, {
      socialMediaType: name,
    });

  shareButtons = [
    {
      name: 'Facebook',
      ShareButton: StyledFacebookShareButton,
      Icon: FacebookIcon,
    },
    {
      name: 'Twitter',
      ShareButton: StyledTwitterShareButton,
      Icon: TwitterIcon,
    },
    {
      name: 'Linkedin',
      ShareButton: StyledLinkedinShareButton,
      Icon: LinkedinIcon,
    },
    {
      name: 'Google+',
      ShareButton: StyledGooglePlusShareButton,
      Icon: GooglePlusIcon,
    },
    {
      name: 'Mail',
      ShareButton: MailShareButton,
      Icon: MailIcon,
      onClick: this.props.openMailApp,
    },
  ];

  render = () => {
    const { open, onClose } = this.props;

    return (
      <Modal open={open} onClose={onClose} width={500}>
        <ModalTitle>{this.modalTitle}</ModalTitle>
        <ModalContent>
          {this.shareButtons.map((button, i, arr) => this.buildShareButton(button, i, arr))}
        </ModalContent>
      </Modal>
    );
  };
}
